import * as Yup from "yup";

export const adminCreditsSchema = Yup.object({
  credits: Yup.number()
    .required("Credits is required")
    .positive("Credits must be greater than 0"),
  description: Yup.string().required("Description is required"),
});
